import fetch from '../fetch';
import EndPoints from '../../data/EndPoints';
import Methods from '../../data/Methods';

export default (companyId, brandId, data) => {
	const headers = { 'content-type': 'application/json' };
	return fetch(
		Methods.POST,
		EndPoints.COMPANY_BRANDS_ID.replace(':companyId', companyId).replace(':id', brandId),
		data,
		headers,
		true
	);
};
